import Asteroids from './asteroids';
import EmiStorm from './emi_storm';
import AlienEncounter from './alien_encounter';
import Container from './container';
import Cryocapsule from './cryocapsule';
import Pirates from './pirates';
import SpaceStation from './space_station';
import Hunger from './hunger';
import LastChanceEvent from './last_chance_event';
import WinEvent from './win_event';
import LooseEvent from './loose_event';
import TutorialEvent from './tutorial_event';
import IntroEvent from './intro_event';
import Breach from './breach';
import DialogUI from '../ui/dialog_ui';

const Events = [Asteroids, EmiStorm, AlienEncounter, Container, Pirates, SpaceStation, Cryocapsule, Hunger/*Breach*/];
const EveryTickEvents = [LastChanceEvent, LooseEvent, WinEvent, IntroEvent];
const TimeFrom = 5000;
const TimeTo = 10000;


export default class Narrator {
    constructor(gameState, ui) {
        this.gameState = gameState;
        this.ui = new DialogUI(ui, gameState);
        this.scheduled = [];
        this.first = true;

    }

    enterEvent(eventKls, source) {
        if (eventKls.canOccur(this.gameState, source)) {
            let event = new eventKls(this.gameState, this.ui, this);
            event.apply(this.gameState);
            if (!event.ended) {
                this.currentEvent = event;
            }
        }
    }

    nextEventDebug() {
        return this.scheduled.length == 0 ? "None" : `${this.scheduled[0].klass.name} in ${(this.scheduled[0].timeLeft/1000).toFixed(1)}s`;
    }

    get nextEventTime() {
        return this.scheduled.length == 0 ? 99999999 : (((this.scheduled[0].timeLeft/1000)+1)|0);
    }

    schedule(kls, time, reset = false) {
        this.scheduled.push({klass: kls, source: this.currentEvent, timeLeft: time});
        if (reset && this.currentEvent) {
            this.gameState.paused = false;
            this.onEnd(this.currentEvent);
        }
    }

    enterEventNum(n) {
        this.enterEvent(Events[n]);
    }

    enterRandomEvent() {
        this.enterEvent(game.rnd.pick(Events));
    }

    scheduleRandomEvent() {
        let time = this.first ? game.rnd.integerInRange(TimeTo, TimeTo*2) : game.rnd.integerInRange(TimeFrom, TimeTo);
        let event = game.rnd.pick(Events.filter(f => f.canOccur(this.gameState)));
        if (event) {
            this.schedule(event, time);
        }
        this.first = false;
    }

    onEnd(event) {
        this.currentEvent = null;
    }

    update() {
        if (this.currentEvent) {
            this.currentEvent.update();
            return;
        }
        //shall not call update if battle
        for (let s of this.scheduled) {
            if (this.gameState.speed) {
                s.timeLeft -= game.time.physicsElapsedMS;
            }
            if (s.timeLeft <= 0 && this.gameState.canShowEvent() ) {
                //todo: guard for multiple events
                this.enterEvent(s.klass, s.source);
                this.scheduled = this.scheduled.filter(s => s.timeLeft > 0);
                break;
            }
        }
        if (this.scheduled.length === 0) {
            this.scheduleRandomEvent();
            //this.schedule(Container, 0);
        }

        if (!this.currentEvent) {
            for (let special of EveryTickEvents) {
                if (special.canOccur(this.gameState)) {
                    this.schedule(special, 0);
                }
            }

        }

    }

    shiftEventCloser(mass = 0) {
        let nearestTime = this.gameState.howMuchTimeToFly(mass);
        if (this.scheduled.length > 0) {
            let event = this.scheduled[0];
            if (event.timeLeft > nearestTime) {
                event.timeLeft = nearestTime*0.9;
            }
        }
    }


}


// WEBPACK FOOTER //
// ./src/states/events/narrator.js